import React, {Component} from 'react';
import { isSimilarObject } from '../../../helper';

export default class CashOutStepFirst extends Component {

    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }
    
    render() {
        const {
            code,
            confirmData,
            handleSmsCode
        } = this.props;
    
        return (
            <div>
                <label style={{display:'block'}}>Ваш код подтверждения</label>
                <input
                    type="number"
                    placeholder="Смс код"
                    className="salert-sms-input"
                    value={code}
                    onChange={(e) => handleSmsCode(e.target.value)}
                    />

                {
                    confirmData && confirmData.non_field_errors ?
                    <div>{confirmData.non_field_errors}</div>
                    : null
                }

                <span style={{display:'block'}}>Для подтверждения действия введите код подтверждения</span>
            </div>
        )   
    }
}


// WEBPACK FOOTER //
// ./src/components/Profile/Balance/CashOutStepSecond.js